export const REDUCED_CARD_THUMBNAIL_SIZES = {
  medium: 60,
  large: 100
};